import { IReproxyPort } from "@services/getMinerList";
import { GetRequest, PostRequest } from "@services/http/BaseRequest";
import { BaseResponse, RecordResponse, RecordsResponse } from "@services/http/responses/BaseResponse";
import useTypedRequest, { castResponse, useTestTypedRequest } from "@utils/hooks/useTypedRequest";


export interface ReproxyStatus {
  //ReproxyAlive: boolean; // система активна / не работает
  ReproxyConnected: number;
  Status: "success" | "error" | string;
  Links: IReproxyPort[];
};


export default function useMinerPortsRepository(
  requester?: typeof useTestTypedRequest | typeof useTypedRequest | undefined
) {

  const request = requester !== undefined ? requester : useTypedRequest;

  const create = request({
    makeRequest(
      minerId: number,
    ) {
      return new PostRequest(
        "admin/reproxy/create",
        {
          miner_id: minerId,
        }
      );
    },
    makeResponse: castResponse<RecordResponse<{ Port: number }>>,
  });

  const list = request({
    makeRequest() {
      return new GetRequest("/admin/reproxy/list")
    },
    makeResponse: castResponse<RecordResponse<ReproxyStatus>>
  });

  const remove = request({
    makeRequest(port: number) {
      return new PostRequest("/admin/reproxy/delete", { port })
    },
    makeResponse: castResponse<BaseResponse>
  });

  return {
    create,
    list,
    remove
  }
}